import { createGlobalStyle } from 'styled-components';

const CssBaseline = createGlobalStyle`
  html,
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  h1,
  p {
    margin: 0;
    padding: 0;
  }
`;

export default CssBaseline;
